export const initMobileMenu = () => {
  const header = document.querySelector('.header');
  const closeButton = header.querySelector('.mobile-menu__close-btn');
  const burgerBtn = document.querySelector('.burger-btn');
  const mobMenuOverlay = document.querySelector('.mobile-menu-overlay');
  const submenuItems = document.querySelectorAll('.menu-nav__item--submenu');

  const openMobileMenu = () => {
    document.documentElement.classList.add('lock-scroll');
    header.classList.add('mob-menu-open');
    header.classList.remove('hide');
    burgerBtn.classList.add('open');
  };

  const closeMobileMenu = () => {
    header.classList.add('mob-menu-hide-anim');
    document.documentElement.classList.remove('lock-scroll');
    burgerBtn.classList.remove('open');

    setTimeout(() => {
      header.classList.remove('mob-menu-open');
      header.classList.remove('mob-menu-hide-anim');

      submenuItems.forEach((item) => {
        if (item.classList.contains('active')) {
          item.classList.remove('active');
          item.querySelector('.menu-nav-submenu__items-list').style.height = '0px';
        }
      });
    }, 250);
  };

  const clickHandler = () => {
    if (header.classList.contains('mob-menu-open')) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  };

  burgerBtn.addEventListener('click', clickHandler);
  mobMenuOverlay.addEventListener('click', clickHandler);
  closeButton.addEventListener('click', closeMobileMenu);
};
